export const getCircles=(state)=>{    
    return Object.keys(state.my_circles.circles).length? state.my_circles.circles : undefined;
}
export const isFetchingCircles = (state) => {
    return state.my_circles.loading;
};

export const shouldFetchCircleDetails=(state, id)=>{
    if(isFetchingCircles(state, id)){
        return false;
    }
    const circles = getCircles(state);
    if(circles && (id in circles)){
        return false;
    }else{
        return true;
    } 
}

export const loadingInitialCirclesList=(state)=>{
    return ( 
        isFetchingCircles(state) && (Object.keys(state.my_circles.circles).length === 0)
    )
}

export const getCircleWithId=(state, id)=>{
    const circles = getCircles(state);    
    return (circles && (id in circles))?circles[id]:null;
}

export const isWhiteMondayCircle=(state, id)=>{
    const circle = getCircleWithId(state, id);
    if(circle){
        return circle.labels.includes('whitemonday');
    }
    return null;
}

export const isPrylpoolenCircle=(state, id)=>{
    const circle = getCircleWithId(state, id);
    if(circle){
        return circle.labels.includes('is_prylpoolen');
    }
    return false;
}

export const hasAgreement=(state, id)=>{
    const circle = getCircleWithId(state, id);
    if(circle){
        return circle.has_agreement;
    }
    return null;
}

export const savingCircle=(state)=>{     
    return state.my_circles.saving;
}

export const invitingFriends=(state)=>{     
    return state.my_circles.inviting_friends;
}

export const markingInterest=(state)=>{     
    return state.my_circles.marking_interest;
}

export const sendingPuzzleOrder=(state)=>{
    return state.my_circles.sending_order;
}

export const isAdmin=(circle, logged_user_guid)=>{
    if(circle){
      return circle.admins.includes(logged_user_guid);
    }
    return null;
  }

export const migratingMembers=(state)=>{
    return state.my_circles.migrating_members;
}